import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const NoticeIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 11.5H8V16.25C8 16.9404 7.44036 17.5 6.75 17.5C6.05964 17.5 5.5 16.9404 5.5 16.25V11.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <mask id="path-2-inside-1_1067_96585" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 3.75C14 2.4375 14 2 13 2L7 5.5H5.5C3.567 5.5 2 7.067 2 9C2 10.933 3.567 12.5 5.5 12.5H7L13 16C14 16 14 15.5625 14 14.25V3.75Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.75C14 2.4375 14 2 13 2L7 5.5H5.5C3.567 5.5 2 7.067 2 9C2 10.933 3.567 12.5 5.5 12.5H7L13 16C14 16 14 15.5625 14 14.25V3.75Z"
        fill="currentColor"
      />
      <path
        d="M13 2V1H12.7297L12.4961 1.13622L13 2ZM7 5.5V6.5H7.27035L7.50387 6.36378L7 5.5ZM7 12.5L7.50387 11.6362L7.27035 11.5H7V12.5ZM13 16L12.4961 16.8638L12.7297 17H13V16ZM13 3C13.1977 3 13.2232 3.02509 13.1773 3.00502C13.1449 2.99083 13.097 2.96286 13.0496 2.91563C13.0028 2.86896 12.9771 2.824 12.9655 2.79857C12.9516 2.76805 12.9735 2.79983 12.9868 2.99195C12.9995 3.17541 13 3.40973 13 3.75H15C15 3.43402 15.0005 3.12147 14.982 2.85376C14.964 2.5947 14.9234 2.27102 14.7845 1.96705C14.6239 1.61574 14.3539 1.33674 13.9789 1.17271C13.6518 1.02959 13.3023 1 13 1V3ZM7.50387 6.36378L13.5039 2.86378L12.4961 1.13622L6.49613 4.63622L7.50387 6.36378ZM7 4.5H5.5V6.5H7V4.5ZM5.5 4.5C3.01472 4.5 1 6.51472 1 9H3C3 7.61929 4.11929 6.5 5.5 6.5V4.5ZM1 9C1 11.4853 3.01472 13.5 5.5 13.5V11.5C4.11929 11.5 3 10.3807 3 9H1ZM5.5 13.5H7V11.5H5.5V13.5ZM13.5039 15.1362L7.50387 11.6362L6.49613 13.3638L12.4961 16.8638L13.5039 15.1362ZM13 14.25C13 14.5903 12.9995 14.8246 12.9868 15.008C12.9735 15.2002 12.9516 15.232 12.9655 15.2014C12.9771 15.176 13.0028 15.131 13.0496 15.0844C13.097 15.0371 13.1449 15.0092 13.1773 14.995C13.2232 14.9749 13.1978 15 13 15V17C13.3022 17 13.6518 16.9704 13.9789 16.8273C14.3539 16.6633 14.6239 16.3843 14.7845 16.0329C14.9234 15.729 14.964 15.4053 14.982 15.1462C15.0005 14.8785 15 14.566 15 14.25H13ZM13 3.75V14.25H15V3.75H13Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_1067_96585)"
      />
      <path
        d="M16 7C16.4562 7.20325 16.8349 7.49498 17.0982 7.84598C17.3614 8.19698 17.5 8.59494 17.5 9C17.5 9.40506 17.3614 9.80302 17.0982 10.154C16.8349 10.505 16.4562 10.7968 16 11"
        fill="currentColor"
      />
      <path
        d="M16 7C16.4562 7.20325 16.8349 7.49498 17.0982 7.84598C17.3614 8.19698 17.5 8.59494 17.5 9C17.5 9.40506 17.3614 9.80302 17.0982 10.154C16.8349 10.505 16.4562 10.7968 16 11L16 7Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoticeIcon;
